<div class="cancel-delivery cancel-delivery__background">
  <img src="assets/images/sky-back.svg"
            class="cancel-delivery__sky-back" alt="">

  <div class="cancel-delivery__content-block">
    <img src="assets/images/circle-with-lines.png"
         class="cancel-delivery__circle" alt="">
  </div>
</div>

<app-cancel-delivery-modal
  [transactionId]="transactionId"
  (close)="closingIsFinish()"
  *ngIf="showCancelDeliveryModal"
></app-cancel-delivery-modal>
<app-notification-modal
  [modalInfo]="cancelSuccess"
  (close)="backToHomePage()"
  *ngIf="showNotificationModal"
></app-notification-modal>
